module.exports = __webpack_public_path__ + "static/media/hanging_folder_white.ea2a6330.svg";